import '../styles/theme.scss';

import { obfuscation, contactPageBottom } from './utils';
import * as animations from './animations';
import * as menus from '@components/menus';
import * as accordions from '@components/accordions';
import * as projects from '@components/projects';
import * as toc from '@components/tocGenerator';
import setupConsent from '@components/consent';

document.addEventListener('DOMContentLoaded', (): void => {
    animations.init();
    menus.init();
    accordions.init();
    projects.init();
    toc.init();
    obfuscation();
    contactPageBottom();
    setupConsent();

    console.info(
        "%c© Copyright Éco Énergies 17%cEvery pixel matters ❤︎ web2do.fr%c⚡ Powered by Wordpress",
        "display:inline-block;color:#fff;background:#0ba1d9;font-size:14px;margin:4px;padding:5px 8px;border-radius:10px;",
        "display:inline-block;color:#fff;background:#32AD87;font-size:14px;margin:4px;padding:5px 8px;border-radius:10px;",
        "display:inline-block;color:#fff;background:#3858e9;font-size:14px;margin:4px;padding:5px 8px;border-radius:10px;"
    );
});

// Tree shaking
import '@components/sliders';
